/* eslint-disable prettier/prettier */
/* eslint-disable consistent-return */
/* eslint-disable react/no-unstable-nested-components */
import React, { useEffect, useState, useRef } from "react";
import { Grid } from "@mui/material";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import * as Sentry from "@sentry/react";
import { ORGANIZATION_STRUCTURE_FIELDS } from "../../../../contants/formFields";
import IntroductionFormApi from "../../../../services/api/introductionForm";
import Styles from "./OrganizationStructure.styles";
import { getOptions } from "../../../../utils";
import { isEmptyObj } from "../../../../utils/helper";
import { OS_REDUX_KEY_MAPPER } from "../../../../contants";
import AutoCompleteDropdown from "../../../../components/common/new/AutoCompleteDropdown/AutoCompleteDropdown";
import { SET_ORGANISATION_STRUCTURE } from "../../../../redux/actionTypes/meta";
import { selectAllSIUsers } from "../../../../redux/selectors/user";

function OrganizationStructure({
  values,
  errors,
  setFieldValue,
  showArea,
  containerStyle,
  required,
  useHiddenInput,
  storeValuesInRedux,
  shouldFetchOtherOS,
  disabledOSKeys,
}) {
  const [areaData, setAreadData] = useState([]);
  const [clusterData, setClusterData] = useState([]);
  const [zoneData, setZoneData] = useState([]);
  const [regionData, setRegionData] = useState([]);
  const [chapterData, setChapterData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const formRequestRef = useRef(true);
  const dispatch = useDispatch();
  const {
    isChapterSi,
    isRegionSi,
    isZoneSi,
    isClusterSi,
    isAreaSi,
    isHelpDesk,
    isHelpDeskAdmin,
  } = useSelector(selectAllSIUsers);

  const getData = async (api, setState, params, setter) => {
    try {
      let response;
      if (params) {
        response = await api({ data: params });
      } else {
        response = await api({});
      }
      setState(response?.data || response || []);
      if (setter) {
        setter();
      }
      if (storeValuesInRedux) {
        const key = isEmptyObj(params)
          ? "areas"
          : OS_REDUX_KEY_MAPPER[Object.keys(params)[0]];
        dispatch({
          type: SET_ORGANISATION_STRUCTURE,
          payload: {
            [key]: response?.data,
          },
        });
      }
    } catch (err) {
      Sentry.captureException(err);
    }
  };

  const fetchAllOtherOS = () => {
    if (values.areaId) {
      getData(IntroductionFormApi.getAllClusters, setClusterData, {
        areaId: values.areaId,
      });
    }
    if (values.clusterId) {
      getData(IntroductionFormApi.getAllZones, setZoneData, {
        clusterId: values.clusterId,
      });
    }
    if (values.zoneId) {
      getData(IntroductionFormApi.getAllRegions, setRegionData, {
        zoneId: values.zoneId,
      });
    }
    if (values.regionId) {
      getData(IntroductionFormApi.getAllChapters, setChapterData, {
        regionId: values.regionId,
      });
    }
    if (values.chapterId) {
      getData(IntroductionFormApi.getAllDistricts, setDistrictData, {
        chapterId: values.chapterId,
      });
    }
    if (values.districtId) {
      getData(IntroductionFormApi.getAllBlocks, setBlockData, {
        districtId: values.districtId,
      });
    }
  };

  useEffect(() => {
    getData(IntroductionFormApi.getAllArea, setAreadData);
    fetchAllOtherOS();
  }, []);

  useEffect(() => {
    if (shouldFetchOtherOS && formRequestRef.current) {
      fetchAllOtherOS();
      formRequestRef.current = false;
    }
  }, [values, shouldFetchOtherOS]);

  return (
    <Grid
      container
      style={{
        border: "1px solid #C4C4C4",
        padding: 10,
        ...(containerStyle ?? {}),
      }}
    >
      {(isHelpDesk ||
        isAreaSi ||
        isClusterSi ||
        isZoneSi ||
        isRegionSi ||
        isChapterSi ||
        isHelpDeskAdmin) && (
        <Grid item md={12} xs={12} style={Styles.gridStyle}>
          <AutoCompleteDropdown
            getOptionLabel={(option) => option.name}
            label="Area"
            name={ORGANIZATION_STRUCTURE_FIELDS.AREA}
            options={getOptions(areaData, "structureId")}
            error={errors[ORGANIZATION_STRUCTURE_FIELDS.AREA]}
            value={values[ORGANIZATION_STRUCTURE_FIELDS.AREA]}
            inputProps={{
              ...((isHelpDesk || isHelpDeskAdmin) && { required }),
            }}
            onChange={(selectedValue) => {
              if (!selectedValue) {
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.AREA, "");
              } else {
                setFieldValue(
                  ORGANIZATION_STRUCTURE_FIELDS.AREA,
                  selectedValue.value
                );
                getData(IntroductionFormApi.getAllClusters, setClusterData, {
                  areaId: selectedValue.value,
                });
              }
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CLUSTER, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.ZONE, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
              setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
              setClusterData([]);
              setZoneData([]);
              setRegionData([]);
              setChapterData([]);
              setDistrictData([]);
              setBlockData([]);
            }}
            useHiddenInput={useHiddenInput}
            disabled={disabledOSKeys.includes(
              ORGANIZATION_STRUCTURE_FIELDS.AREA
            )}
          />
        </Grid>
      )}
      {(isHelpDesk ||
        isAreaSi ||
        isClusterSi ||
        isZoneSi ||
        isRegionSi ||
        isChapterSi ||
        isHelpDeskAdmin) &&
        (isAreaSi ||
          isClusterSi ||
          isZoneSi ||
          isRegionSi ||
          isChapterSi ||
          showArea) && (
          <Grid item md={12} xs={12} style={Styles.gridStyle}>
            <AutoCompleteDropdown
              label="Cluster"
              getOptionLabel={(option) => option.name}
              name={ORGANIZATION_STRUCTURE_FIELDS.CLUSTER}
              options={getOptions(clusterData, "structureId")}
              error={errors[ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]}
              value={values[ORGANIZATION_STRUCTURE_FIELDS.CLUSTER]}
              inputProps={{ ...(isAreaSi && { required }) }}
              disabled={
                !values[ORGANIZATION_STRUCTURE_FIELDS.AREA] ||
                disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.CLUSTER)
              }
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CLUSTER, "");
                } else {
                  setFieldValue(
                    ORGANIZATION_STRUCTURE_FIELDS.CLUSTER,
                    selectedValue.value
                  );
                  getData(IntroductionFormApi.getAllZones, setZoneData, {
                    clusterId: selectedValue.value,
                  });
                }
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.ZONE, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setZoneData([]);
                setRegionData([]);
                setChapterData([]);
                setDistrictData([]);
                setBlockData([]);
              }}
              useHiddenInput={useHiddenInput}
            />
          </Grid>
        )}
      {(isHelpDesk ||
        isAreaSi ||
        isClusterSi ||
        isZoneSi ||
        isRegionSi ||
        isChapterSi ||
        isHelpDeskAdmin) &&
        (isAreaSi ||
          isClusterSi ||
          isZoneSi ||
          isRegionSi ||
          isChapterSi ||
          showArea) && (
          <Grid item md={12} xs={12} style={Styles.gridStyle}>
            <AutoCompleteDropdown
              label="Zone"
              getOptionLabel={(option) => option.name}
              name={ORGANIZATION_STRUCTURE_FIELDS.ZONE}
              options={getOptions(zoneData, "structureId")}
              error={errors[ORGANIZATION_STRUCTURE_FIELDS.ZONE]}
              value={values[ORGANIZATION_STRUCTURE_FIELDS.ZONE]}
              inputProps={{ ...(isAreaSi && { required }) }}
              disabled={
                !values[ORGANIZATION_STRUCTURE_FIELDS.CLUSTER] ||
                disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.ZONE)
              }
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.ZONE, "");
                } else {
                  setFieldValue(
                    ORGANIZATION_STRUCTURE_FIELDS.ZONE,
                    selectedValue.value
                  );
                  getData(IntroductionFormApi.getAllRegions, setRegionData, {
                    zoneId: selectedValue.value,
                  });
                }
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setRegionData([]);
                setChapterData([]);
                setDistrictData([]);
                setBlockData([]);
              }}
              useHiddenInput={useHiddenInput}
            />
          </Grid>
        )}

      {(isHelpDesk ||
        isClusterSi ||
        isZoneSi ||
        isRegionSi ||
        isChapterSi ||
        isHelpDeskAdmin) &&
        (isClusterSi || isZoneSi || isRegionSi || isChapterSi || showArea) && (
          <Grid item md={12} xs={12} style={Styles.gridStyle}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Region"
              name={ORGANIZATION_STRUCTURE_FIELDS.REGION}
              options={getOptions(regionData, "structureId")}
              error={errors[ORGANIZATION_STRUCTURE_FIELDS.REGION]}
              disabled={
                !values[ORGANIZATION_STRUCTURE_FIELDS.ZONE] ||
                disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.REGION)
              }
              value={values[ORGANIZATION_STRUCTURE_FIELDS.REGION]}
              inputProps={{ ...(isZoneSi && { required }) }}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.REGION, "");
                } else {
                  setFieldValue(
                    ORGANIZATION_STRUCTURE_FIELDS.REGION,
                    selectedValue.value
                  );
                  getData(IntroductionFormApi.getAllChapters, setChapterData, {
                    regionId: selectedValue.value,
                  });
                }
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setChapterData([]);
                setDistrictData([]);
                setBlockData([]);
              }}
              useHiddenInput={useHiddenInput}
            />
          </Grid>
        )}
      {(isHelpDesk || isRegionSi || isChapterSi || isHelpDeskAdmin) &&
        (isRegionSi || isChapterSi || showArea) && (
          <Grid item md={12} xs={12} style={Styles.gridStyle}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Chapter"
              name={ORGANIZATION_STRUCTURE_FIELDS.CHAPTER}
              options={getOptions(chapterData, "structureId")}
              error={errors[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]}
              value={values[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER]}
              inputProps={{ ...(isRegionSi && { required }) }}
              disabled={
                !values[ORGANIZATION_STRUCTURE_FIELDS.REGION] ||
                disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER)
              }
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.CHAPTER, "");
                } else {
                  setFieldValue(
                    ORGANIZATION_STRUCTURE_FIELDS.CHAPTER,
                    selectedValue.value
                  );
                  getData(
                    IntroductionFormApi.getAllDistricts,
                    setDistrictData,
                    {
                      chapterId: selectedValue.value,
                    }
                  );
                }
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
                setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                setDistrictData([]);
                setBlockData([]);
              }}
              useHiddenInput={useHiddenInput}
            />
          </Grid>
        )}
      {(isHelpDesk || isRegionSi || isChapterSi || isHelpDeskAdmin) &&
        (isRegionSi || isChapterSi || showArea) && (
          <Grid item md={12} xs={12} style={Styles.gridStyle}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="District"
              name={ORGANIZATION_STRUCTURE_FIELDS.DISTRICT}
              options={getOptions(districtData, "structureId")}
              error={errors[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
              value={values[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
              inputProps={{ ...(isChapterSi && { required }) }}
              disabled={
                !values[ORGANIZATION_STRUCTURE_FIELDS.CHAPTER] ||
                disabledOSKeys.includes(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT)
              }
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.DISTRICT, "");
                } else {
                  setFieldValue(
                    ORGANIZATION_STRUCTURE_FIELDS.DISTRICT,
                    selectedValue.value
                  );
                  getData(IntroductionFormApi.getAllBlocks, setBlockData, {
                    districtId: selectedValue.value,
                  });
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                  setBlockData([]);
                }
              }}
              useHiddenInput={useHiddenInput}
            />
          </Grid>
        )}
      {(isHelpDesk || isChapterSi || isHelpDeskAdmin) &&
        (isChapterSi || showArea) && (
          <Grid item md={12} xs={12} style={Styles.gridStyle}>
            <AutoCompleteDropdown
              getOptionLabel={(option) => option.name}
              label="Block"
              name={ORGANIZATION_STRUCTURE_FIELDS.BLOCK}
              options={getOptions(blockData, "structureId")}
              error={errors[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
              value={values[ORGANIZATION_STRUCTURE_FIELDS.BLOCK]}
              inputProps={{ ...(isChapterSi && { required }) }}
              disabled={!values[ORGANIZATION_STRUCTURE_FIELDS.DISTRICT]}
              onChange={(selectedValue) => {
                if (!selectedValue) {
                  setFieldValue(ORGANIZATION_STRUCTURE_FIELDS.BLOCK, "");
                } else {
                  setFieldValue(
                    ORGANIZATION_STRUCTURE_FIELDS.BLOCK,
                    selectedValue.value
                  );
                  getData(IntroductionFormApi.getAllBlocks, setBlockData, {
                    blockId: selectedValue.value,
                  });
                }
              }}
              useHiddenInput={useHiddenInput}
            />
          </Grid>
        )}
    </Grid>
  );
}

const propTypes = {
  errors: PropTypes.objectOf(PropTypes.string).isRequired,
  setFieldValue: PropTypes.func.isRequired,
  values: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  showArea: PropTypes.bool,
  containerStyle: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ),
  required: PropTypes.bool,
  useHiddenInput: PropTypes.bool,
  storeValuesInRedux: PropTypes.bool,
  shouldFetchOtherOS: PropTypes.bool,
  disabledOSKeys: PropTypes.arrayOf(PropTypes.string),
};

const defaultProps = {
  showArea: false,
  containerStyle: null,
  required: true,
  useHiddenInput: false,
  storeValuesInRedux: false,
  shouldFetchOtherOS: false,
  disabledOSKeys: [],
};

OrganizationStructure.propTypes = propTypes;
OrganizationStructure.defaultProps = defaultProps;

export default OrganizationStructure;
